import React from 'react'
import { Collection, WhenModelValue } from '@morningtrain/react-resources'
import * as Filters from 'support/filters'

export default function ConstrainedScheduleSlotsCollection ({
  operationName = 'grouped_by_day',
  children
}) {
  return (
    <WhenModelValue name='id'>
      <Collection resourceName='shifts.schedule_slot' operationName={operationName}>
        <Filters.StaticFilter name='$per_page' value='0' />
        <Filters.ModelValueFilter name='schedule_id' modelKey='id' />
        {children}
      </Collection>
    </WhenModelValue>
  )
}
